import React from "react";
import { Navigation } from "react-feather";

// Google Maps turn-by-turn directions to a point, from wherever the person
// opening it is. On a phone this hands over to the Maps app.
export const directionsUrl = (latitude, longitude) =>
  `https://www.google.com/maps/dir/?api=1&destination=${Number(latitude)},${Number(longitude)}`;

/**
 * "Navigate" link for any row or popup that carries GPS coordinates
 * (2026-09-19). Renders nothing without coordinates. Stops the click from
 * bubbling so it can sit inside a clickable table row.
 */
const NavigateLink = ({ latitude, longitude, label = "Navigate", className = "" }) => {
  if (latitude == null || longitude == null) return null;
  return (
    <a
      href={directionsUrl(latitude, longitude)}
      target="_blank"
      rel="noopener noreferrer"
      className={`d-inline-flex align-items-center gap-1 text-nowrap ${className}`}
      onClick={(e) => e.stopPropagation()}
      title="Open directions in Google Maps"
    >
      <Navigation size={13} /> {label}
    </a>
  );
};

export default NavigateLink;
